import ProtectedRoute from 'components/ProtectedRoute'
import useFlag from 'hooks/useFlag'
import React from 'react'
import { Redirect, Switch } from 'react-router-dom'
import Detail from './Detail'
import Landing from './Landing'

const UserLists: React.FC = () => {
  const featureEnabled = useFlag('self-serve-list-upload', false)

  if (!featureEnabled) return <Redirect to="/" />

  return (
    <div className="full-height grey-05-bkg">
      <Switch>
        <ProtectedRoute
          exact
          path="/user_lists"
          component={Landing}
          redirect="/"
          resource="UserLists"
          accessType="access"
        />
        <ProtectedRoute
          exact
          path="/user_lists/:id/:tab?"
          component={Detail}
          redirect="/user_lists"
          resource="UserLists"
          accessType="access"
        />
      </Switch>
    </div>
  )
}

export default UserLists
